import React, { forwardRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import Options from './Options';
import Handle from './Handle';
import { StyledSelect } from './styles';
import Error from '../Error';

const propTypes = {
  error: PropTypes.string
};

const defaultProps = {
  error: null
};

const Select = forwardRef((props, ref) => {
  const { error } = props;

  return (
    <Fragment>
      <StyledSelect ref={ref} dropdownHandleRenderer={Handle} dropdownRenderer={Options} {...props} />
      {error && <Error>{error}</Error>}
    </Fragment>
  );
});

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
export default Select;
